import Consent from './component/consent';
import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function App() {
  const [init, setInit] = useState(true);
  let query = useQuery();
  let lang = query.get("lang")
  
  const { i18n } = useTranslation();
  useEffect(() => {
    if(init){
      lang = (lang==="c" || lang==="zh")?"zh":"en";
      i18n.changeLanguage(lang);
      setInit(false);
    }
  })
  
  return (
    <div className="App">
      <Consent 
        sid={query.get("sid")}
        ticket={query.get("ticket")}
        brand={query.get("brand")}
        lang={lang}
        msisdn={query.get("msisdn")}
        isTest={query.get("isTest")}
      ></Consent>
    </div>
  );
}

export default App;
